import { render, staticRenderFns } from "./projectManager.vue?vue&type=template&id=0850992c"
import script from "./projectManager.vue?vue&type=script&lang=js"
export * from "./projectManager.vue?vue&type=script&lang=js"
import style0 from "./projectManager.vue?vue&type=style&index=0&id=0850992c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports